import React, { useMemo } from "react";
import styled from "styled-components";
import { theme } from "uikit";

import { ChatMessage as ChatMessageServices } from "../../../../../../../../../../../services";
import {
	isObject,
	getUserData,
	getFullTitle,
} from "../../../../../../../../tools";
import { StyledColumn } from "../../../../../../../../../../common";

import Reference from "./components/Reference";

const Root = styled(StyledColumn)<{ bgColor?: boolean }>`
	position: relative;

	padding: 6px 12px;
	white-space: pre-wrap;
	font-family: Lato;
	font-size: 14px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0px;
	text-align: left;
	color: ${({ bgColor }) => (bgColor ? "#ffffff" : theme.colors.primary)};
	background-color: ${({ bgColor }) => (bgColor ? "#03a9f5" : "#dcefdc")};
`;

const Message: React.FC<Message.Props> = ({ data, onClickFindParent }) => {
	const { message, isCurrentUser } = data;

	// let messageContent: React.ReactNode = null;

	const messageContent = useMemo<React.ReactNode>(() => {
		if (isObject(message)) {
			// * Reply to a message
			const userData = getUserData(message);
			const { id: parentId } = message;

			if (!userData || !parentId) return <></>;

			const fullTitle = getFullTitle(userData);
			const contentAnswer = message?.content ?? "";

			return (
				<Reference
					data={{
						isCurrentUser,
						text: contentAnswer,
						title: fullTitle,
						parentId,
					}}
					onClickFindParent={onClickFindParent}
				/>
			);
		}

		if (typeof message === "string") return <>{message}</>;

		return <></>;
	}, [message, isCurrentUser, onClickFindParent]);

	return (
		<Root bgColor={isCurrentUser} gap="8px">
			{messageContent}
		</Root>
	);
};

declare namespace Message {
	export interface Props {
		data: {
			message: string | ChatMessageServices.OutputGrouped.ChatMessage;
			isCurrentUser: boolean;
		};
		onClickFindParent?: (parentId: number) => void;
	}
}

export default Message;
